<template>
  <div>
    <ValidationProvider v-if="edit===1" ref="ValidationProvider" v-slot="{ errors }" name="封面图片" rules="required">
      <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
        <el-upload
          v-if="edit"
          ref="uploadImg"
          action="#"
          list-type="picture"
          :on-exceed="handleExceed"
          :auto-upload="false"
          :on-change="fileChange"
          :show-file-list="false"
          :file-list="fileList"
          accept=".jpg,.png"
        >
          <el-input v-model="inputName" readonly="true" placeholder="选择封面图片">
            <el-button slot="append" icon="el-icon-upload2" />
          </el-input>
        </el-upload>
      </el-tooltip>
    </ValidationProvider>
    <el-image v-if="file" fit="cover" style="max-width:120px;margin-top: 10px;" :src="file" />
    <el-image v-if="showImg&&!file" fit="cover" style="max-width:120px;margin-top: 10px;" :src="api" />
    <el-dialog
      title="请裁剪"
      :visible.sync="dialogVisible"
      width="100%"
      top="0"
    >
      <div class="btn">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="ok">确 定</el-button>
      </div>
      <div style="width:100%" :style="{'height':vueHeight}">
        <vue-cropper
          ref="cropper"
          :img="originImg"
          output-type="png"
          :full="true"
          auto-crop-width="1900"
          auto-crop-height="1900"
          :center-box="true"
          :can-scale="true"
          :auto-crop="true"
          :fixed="true"
          :can-move="true"
          :fixed-number="[16, 9]"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
    props: {
        fname: {
            type: String,
            default: ''
        },
        fdata: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        },
        vo: {
            type: Object,
            default: () => { return {} }
        },
        edit: {
            type: Number,
            default: 0
        },
        url: {
            type: String,
            default: ''
        },
        showImg: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            fileList: [],
            dialogVisible: false,
            originImg: '',
            file: '',
            inputName: '',
            api: '',
            isEdit: '',
            files: '',
            vueHeight: ''
        }
    },
    created() {
        this.inputName = this.vo[this.fname]
        this.isEdit = this.$route.query.id
        this.api = process.env.VUE_APP_BASE_API + `${this.url}/download?dataField=${this.fdata}&nameField=${this.fname}&id=${this.vo.id}&httpPort=${location.port}`
    },
    mounted() {
        this.vueHeight = document.body.clientHeight - 100 + 'px'
    },
    methods: {
        fileChange(files) {
            this.files = ''
            this.files = files
            this.dialogVisible = true
            this.getBase64(files.raw, imageUrl => {
                this.originImg = imageUrl
            })
        },
        getBase64(img, callback) {
            const reader = new FileReader()
            reader.addEventListener('load', () => callback(reader.result))
            reader.readAsDataURL(img)
        },
        cancel() {
            this.dialogVisible = false
            this.inputName = ''
            this.$refs.uploadImg.clearFiles()
        },
        clearBorder(canvas) {
            const ctx = canvas.getContext('2d')
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
            const data = imageData.data
            const length = data.length

            for (let i = 0; i < length; i += 4) {
                const r = data[i]
                const g = data[i + 1]
                const b = data[i + 2]
                // 如果当前像素的红、绿、蓝三个通道中有任意一个不为0，则该像素不是边框，将其设为透明
                if (r !== 0 || g !== 0 || b !== 0) {
                    data[i + 3] = 0
                }
            }

            ctx.putImageData(imageData, 0, 0)
        },
        ok() {
            console.log(126, this)
            this.$vnode.context.$set(this.$vnode.context.vo, this.fileName, this.files.name)
            this.inputName = this.files.name
            this.$refs.cropper.getCropData(data => {
                this.file = data
                const files = this.dataURLtoBlob(data, this.inputName)
                // console.log(102, this.dataURLtoBlob(data, this.inputName))
                this.$bus.emit('firstUpload', files, this.files.name)
            })
            this.dialogVisible = false
        },
        handleExceed(files, fileList) {
            this.$message.warning('只能上传一张图片，要替换图片请先移除原来图片')
        },
        // base64转blob
        dataURLtoBlob(dataurl, fileName) {
            var arr = dataurl.split(',')
            var mime = arr[0].match(/:(.*?);/)[1]
            var bstr = atob(arr[1])
            var n = bstr.length
            var u8arr = new Uint8Array(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new File([u8arr], fileName, { type: mime })
        },
        // 将blob转换为file
        blobToFile(theBlob, fileName) {
            theBlob.lastModifiedDate = new Date()
            theBlob.name = fileName
            theBlob.uid = new Date().getTime()
            return new window.File(theBlob, fileName)
        },
        deleteImg() {
            this.file = ''
            this.$refs.uploadImg.clearFiles()
            this.inputName = ''
        }
    }
}
</script>

  <style lang="scss" scoped>
  /deep/.el-dialog__header{
      display: none !important;
  }
  .btn{
      height: 50px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
  }
  </style>
